import type { FinancialNumber } from 'financial-number'
import fnum from 'shared/number'
import { validate as is_valid_number_string } from 'financial-arithmetic-functions'

export const try_to_format_anything_as_dollars = (n: number | { toString: () => string } | FinancialNumber) => {
	const is_invalid_number = typeof n === `number` && !Number.isFinite(n)
	const raw_string_value = n.toString()
	if (is_invalid_number || !is_valid_number_string(raw_string_value)) {
		return n.toString()
	}

	return format_money_$(raw_string_value)
}

export const format_money = (n: number | string | FinancialNumber) => {
	if (typeof n === `number`) {
		n = /^(\d+)(\.\d+)?e[-+]\d+$/.test(n.toString()) // scientific notation
			? n.toPrecision(100)
			: n.toString()
	}
	const string = fnum(n).toString(2)

	return add_commas_to_number_string(string)
}

export const format_money_$ = (n: string | FinancialNumber) => add_dollar_sign(format_money(n))

export const format_money_$_with_optional_cents = (n: string | FinancialNumber) => {
	const formatted = format_money_$(n)

	if (formatted.slice(-3) === `.00`) {
		return formatted.slice(0, -3)
	}

	return formatted
}

export const add_commas_to_number_string = (str: string) => {
	const [ dollars_string, fractional_string ] = str.split(`.`)

	const dollars_with_commas = add_commas_to_integer_string(dollars_string)

	return fractional_string
		? dollars_with_commas + `.` + fractional_string
		: fractional_string
}

export const add_commas_to_integer_string = (str: string) => {
	const starting_character = str[0] === `-` ? 1 : 0
	let output = ``
	for (let i = str.length - 3; i > -3; i -= 3) {
		const starting_index = Math.max(0, i)
		output = str.slice(starting_index, i + 3) + output
		if (i > starting_character) {
			output = `,` + output
		}
	}
	return output
}

const add_dollar_sign = (str: string) => {
	if (str[0] === `-`) {
		return `-$` + str.slice(1)
	}

	return `$` + str
}

